import { colors } from '../../Colors/colors'

export const stagesTheme = {
   light: {
      common: {
         stagesBGColor: 'bg-gray-100',
         iconFillColor: colors['primary-600'],
         buttonBGColor: '!bg-transparent',
         noBGColor: '!bg-transparent',
         defaultBorderColor: 'border-gray-300',
         defaultHeaderTextColor: 'text-gray-900',
         defaultDescriptionColor: 'text-gray-600',
         closeIconFillColor: colors['gray-500'],
         dotsMoveIconFillColor: colors['gray-400'],
         noDataViewHeaderTextColor: 'text-gray-700',
         collapseCardTextColor: 'text-gray-900',
         chevronIconColor: colors['gray-500'],
         defaultBGColor: 'bg-white',
         plusIconColor: colors['gray-500'],
         colors: {
            BLUE: 'bg-blue-600',
            BLUE_DARK: 'bg-blue-dark-600',
            BLUE_LIGHT: 'bg-blue-light-600',
            CYAN: 'bg-cyan-600',
            FUCHSIA: 'bg-fuchsia-600',
            GREEN: 'bg-green-600',
            GREEN_LIGHT: 'bg-green-light-600',
            INDIGO: 'bg-indigo-600',
            MOSS: 'bg-moss-600',
            ORANGE: 'bg-orange-600',
            ORANGE_DARK: 'bg-orange-dark-600',
            PINK: 'bg-pink-600',
            PURPLE: 'bg-purple-600',
            ROSE: 'bg-rose-600',
            TEAL: 'bg-teal-600',
            VIOLET: 'bg-violet-600',
            YELLOW: 'bg-yellow-600'
         },
         errorMessages: {
            userIsNotAdministrator: {
               containerBGColor: 'bg-gray-100',
               titleColor: 'text-gray-900',
               descriptionColor: 'text-gray-600'
            }
         },
         sidePaneFieldCard: {
            sectionNameTextColor: 'text-gray-700',
            sectionDescriptionTextColor: 'text-gray-500',
            sectionCardBGColor: 'bg-primary-50',
            sectionCardBorderColor: 'border-primary-600',
            headerTextColor: 'text-gray-900',
            descriptionTextColor: 'text-gray-600',
            closeIconColor: colors['gray-500'],
            defaultBorderColor: 'border-gray-200',
            selectedSectionTextColor: 'text-primary-800',
            selectedSectionDescriptionTextColor: 'text-primary-700',
            selectedSectionCheckboxBorderColor: colors['primary-300'],
            selectedSectionCheckboxColor: colors['primary-600'],
            selectedSectionCheckboxBGColor: 'bg-primary-100',
            unSelectedSectionCheckboxBorderColor: colors['gray-300'],
            unSelectedSectionCheckboxBGColor: 'bg-gray-100'
         }
      },
      header: {
         textColor: 'text-gray-900',
         borderColor: 'border-gray-300',
         headerBGColor: 'bg-base-white',
         refreshHandlerBGColor: '!bg-white'
      },
      body: {
         noStagesTextColor: 'text-gray-700',
         noStagesDescriptionColor: 'text-gray-600',
         containerBGColor: 'bg-gray-100'
      },
      stageCard: {
         headerTextColor: 'text-gray-600',
         selectedCardBorderColor: 'border-primary-600',
         cardBGColor: 'bg-base-white',
         dotsMoveIconFillColor: colors['gray-400']
      },
      createStageModal: {
         headerTextColor: 'text-gray-900',
         descriptionTextColor: 'text-gray-600',
         closeIconFillColor: colors['gray-500'],
         borderColor: 'border-gray-300'
      },
      stageDetails: {
         borderColor: 'border-gray-300',
         cardBgColor: 'bg-base-white',
         titleColor: 'text-gray-700',
         descColor: 'text-gray-600'
      },
      stageFieldsList: {
         dotsMoveIconFillColor: colors['gray-400'],
         eyeIconColor: colors['gray-500'],
         plusIconColor: colors['primary-600'],
         textColor: 'text-gray-700',
         fieldIconColor: colors['gray-500'],
         listItemHoverColor: 'hover:bg-gray-100'
      },
      expandableCard: {
         cardBgColor: 'bg-white',
         cardTitleColor: 'text-gray-700',
         cardDescriptionColor: 'text-gray-600',
         cardIconColor: colors['gray-600'],
         iconFillColor: colors['primary-600']
      },
      stageTransitionsOverviewCard: {
         backgroundColor: 'bg-white',
         plusIconColor: colors['gray-700'],
         disabledPlusIconColor: colors['gray-300'],
         editIconColor: colors['primary-600'],
         noDataTitleColor: 'text-gray-700',
         noDataDescriptionColor: 'text-gray-600',
         cardTitleColor: 'text-gray-700',
         cardDescriptionColor: 'text-gray-600',
         noDataContainerBorderColor: 'border-gray-300',
         tooltipBgColor: 'bg-gray-900'
      },
      transitions: {
         titleTextColor: 'text-gray-900',
         descriptionTextColor: 'text-gray-600',
         closeIconColor: colors['error-600'],
         stagesList: {
            titleTextColor: 'text-gray-600',
            bgColor: 'bg-gray-100',
            borderColor: 'border-gray-300'
         },
         customControl: {
            plusIconColor: colors['gray-500'],
            minusIconColor: colors['gray-500'],
            percentageTextColor: 'text-gray-700',
            percentageLeftAndRightBorderColor: 'border-gray-300',
            customControllerBgColor: 'bg-base-white',
            zoomButtonHoverColor: 'hover:bg-base-white'
         }
      },
      detailsView: {
         stageTextColor: 'text-gray-900',
         focusedCardBorderColor: 'border-primary-300'
      },
      stageTaskTemplates: {
         closeIconFillColor: colors['gray-500'],
         dotsMoveIconFillColor: colors['gray-400'],
         taskTemplateTextColor: 'text-gray-700',
         plusIconFillColor: colors['primary-600'],
         tickMarkIconColor: colors['primary-600'],
         customOptionHoverBgColor: 'hover:bg-gray-50',
         selectedOptionBGColor: 'bg-gray-50',
         notSelectedOptionBGColor: '!bg-transparent',
         optionsTextColor: 'text-gray-700',
         listItemHoverColor: 'hover:bg-gray-100'
      },
      stagesSidePane: {
         defaultBorderColor: 'border-gray-300',
         sidePaneTaskLabelTextColor: 'text-gray-500',
         lineSeparatorBGColor: 'bg-gray-300',
         dotsMoveIconFillColor: colors['gray-500'],
         footerBorderColor: 'border-gray-300',
         defaultErrorStateIconColor: colors['error-600'],
         defaultErrorStageTextColor: 'text-error-600',
         fieldsLimitTextColor: 'text-gray-900'
      },
      stageBoardRoles: {
         sectionBorderColor: 'border-t-gray-300 bg-gray-300',
         rolesListItemTextColor: 'text-gray-700',
         rolesListItemBgColor: 'bg-gray-50',
         rolesListItemBorderColor: 'border-gray-300',
         rolesSectionTitleColors: 'text-gray-500'
      },
      stageTransitionNotAllowed: {
         titleColors: 'text-gray-900',
         descriptionColors: 'text-gray-600'
      }
   },
   dark: {}
}
